var React = require('react');

function ExternalLinkArrowSkinny (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 15.5L15 5.5","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6.875 5.5H15V13.625","stroke":"white","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ExternalLinkArrowSkinny.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = ExternalLinkArrowSkinny;

ExternalLinkArrowSkinny.default = ExternalLinkArrowSkinny;
